import { render } from "./MemberWelcomePage.vue?vue&type=template&id=517cbcac"
import script from "./MemberWelcomePage.vue?vue&type=script&lang=js"
export * from "./MemberWelcomePage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pavithram.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__